<template>
    <div>
        <div v-if="isOpen" class="backdrop" @click="closeDrawer"></div>
        <div :class="['drawer', { 'drawer--open': isOpen }]">
            <div class="drawer-header">
                <button @click="closeDrawer">X</button>

                <div class="header-title">
                    <h2>Profile Completion</h2>
                    <div class="percent">{{ data.profilePercentComplete + '%' }}</div>
                </div>
                <div class="progress-bar">
                    <div class="progress" :style="{ width: data.profilePercentComplete + '%' }"></div>
                </div>
            </div>
            <div class="drawer-content">
                <div class="section">
                    <ul>
                        <li>
                            <span class="item-title">
                                <span v-if="data.personalDetails.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Personal Details
                            </span>

                            <a class="action-button" :href="data.personalDetails.link"
                                :class="{ 'edit': data.personalDetails.edit, 'add': !data.personalDetails.edit }">
                                {{ data.personalDetails.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                        <li>
                            <span class="item-title">
                                <span v-if="data.introduceYourSelf.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Introduce Your Self
                            </span>

                            <a class="action-button" :href="data.introduceYourSelf.link"
                                :class="{ 'edit': data.introduceYourSelf.edit, 'add': !data.introduceYourSelf.edit }">
                                {{ data.introduceYourSelf.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                        <li>
                            <span class="item-title">
                                <span v-if="data.yourBio.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Your Bio
                            </span>

                            <a
                                class="action-button"
                                :href="data.yourBio.link"
                                :class="{ 'edit': data.yourBio.edit, 'add': !data.yourBio.edit }">
                                {{ data.yourBio.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                    </ul>

                    <h3>CV Details</h3>
                    <ul>
                        <li>
                            <span class="item-title">
                                <span v-if="data.cvDetails.languages.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Languages
                            </span>

                            <a class="action-button" :href="data.cvDetails.languages.link"
                                :class="{ 'edit': data.cvDetails.languages.edit, 'add': !data.cvDetails.languages.edit }">
                                {{ data.cvDetails.languages.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                        <li>
                            <span class="item-title">
                                <span v-if="data.cvDetails.education.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Education
                            </span>

                            <a class="action-button" :href="data.cvDetails.education.link"
                                :class="{ 'edit': data.cvDetails.education.edit, 'add': !data.cvDetails.education.edit }">
                                {{ data.cvDetails.education.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                        <li>
                            <span class="item-title">
                                <span v-if="data.cvDetails.workExperience.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Work Experience
                            </span>

                            <a class="action-button"
                                :href="data.cvDetails.workExperience.link"
                                :class="{ 'edit': data.cvDetails.workExperience.edit, 'add': !data.cvDetails.workExperience.edit }">
                                {{ data.cvDetails.workExperience.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                        <li>
                            <span class="item-title">
                                <span v-if="data.cvDetails.reference.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Reference
                            </span>

                            <a class="action-button"
                                :href="data.cvDetails.reference.link"
                                :class="{ 'edit': data.cvDetails.reference.edit, 'add': !data.cvDetails.reference.edit }">
                                {{ data.cvDetails.reference.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                    </ul>
                    <h3>AIMS Modules</h3>
                    <small v-if="data.aimModules.message">{{ data.aimModules.message }}</small>
                    <ul>
                        <li>
                            <span class="item-title">
                                <span v-if="data.aimModules.cognitive.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Congnitive Indicator
                            </span>

                            <a
                                class="action-button"
                                :href="data.aimModules.cognitive.disabled ? '#' : data.aimModules.cognitive.link"
                                :class="{ 'edit': data.aimModules.cognitive.edit, 'add': !data.aimModules.cognitive.edit, 'disabled': data.aimModules.cognitive.disabled }">
                                {{ data.aimModules.cognitive.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                        <li>
                            <span class="item-title">
                                <span v-if="data.aimModules.questionnaire.completed" class="checkmark">
                                    <i class="fa fa-check"></i>
                                </span>
                                <span v-else class="plusmark">
                                    <i class="fa fa-plus"></i>
                                </span>
                                Questionnaire
                            </span>

                            <a
                                class="action-button"
                                :href="data.aimModules.questionnaire.disabled ? '#' : data.aimModules.questionnaire.link"
                                :class="{ 'edit': data.aimModules.questionnaire.edit, 'add': !data.aimModules.questionnaire.edit, 'disabled': data.aimModules.questionnaire.disabled }">
                                {{ data.aimModules.questionnaire.edit ? 'EDIT' : 'ADD' }}
                            </a>
                        </li>
                    </ul>
                    <slot></slot>
                    <div class="edit-consent">
                        <div class="title">
                            Give Edit Consent
                            <span><i class="fa-regular fa-circle-question"></i></span>
                        </div>
                        <div>
                            <toggle-button
                                :labels="{checked: 'YES', unchecked: 'NO'}"
                                :color="{checked: '#69BE28', unchecked: '#586674', disabled: '#CCCCCC'}"
                                :switch-color="{checked: '#FFFFFF', unchecked: '#FFFFFF'}"
                                @change="onChangeEventHandler"
                                v-model="editConsent"
                                :value="editConsent"
                                :sync="true"
                            />
                        </div>
                    </div>
                    <div>Do you agree to give your consent to allow recruiters to edit your profile?</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import axios from 'axios';

export default {
    components: {
        ToggleButton
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {
                profilePercentComplete: 0,
                personalDetails: {
                    completed: false,
                    edit: true
                },
                introduceYourSelf: {
                    completed: false,
                    edit: true
                },
                yourBio: {
                    completed: false,
                    edit: true
                },
                cvDetails: {
                    languages: {
                        completed: false,
                        edit: true
                    },
                    education: {
                        completed: false,
                        edit: true
                    },
                    workExperience: {
                        completed: false,
                        edit: true
                    },
                    reference: {
                        completed: false,
                        edit: true
                    }
                },
                aimModules: {
                    cognitive: {
                        completed: false,
                        edit: true,
                        disabled: false
                    },
                    questionnaire: {
                        completed: false,
                        edit: true,
                        disabled: false
                    }
                },
                editConsent: false
            }
        }
    },
    data() {
        return {
            editConsent: false
        }
    },
    methods: {
        closeDrawer() {
            this.$emit('close');
        },
        editItem(item) {
            // Logic to edit item
            console.log(`Editing ${item.title}`);
        },
        onChangeEventHandler() {
            // Logic to handle toggle button change event
            console.log('Toggle button changed', this.editConsent);

            axios.post(`/ajax/users/give-consent`, {recruiters_can_edit: this.editConsent}).then(function (response) {

            });
        }
    },
    mounted() {
        this.editConsent = this.data.editConsent
    }
}
</script>

<style lang="scss" scoped>
@import './assets/scss/frontend/base/colour_vars.scss';

.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 999;
    /* Pastikan backdrop di belakang drawer */
}

.drawer--open {
    right: 0 !important;
}

.drawer {
    position: fixed;
    top: 0;
    right: -320px;
    width: 320px;
    height: 100%;
    background-color: white;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
    transition: right 0.3s ease;
    z-index: 1000;

    .drawer-header {
        background-color: $light-gray-drawer;
        padding: 10px;
        position: relative;

        .header-title {
            margin-top: 20px;
            display: flex;
            align-items: center;
            color: white !important;
            font-weight: bold;

            h2 {
                margin: 0;
                font-size: 16px !important;
                flex-grow: 1;
                text-transform: capitalize !important;
                color: white !important;
            }

            .percent {
                font-size: 16px;
            }
        }

        .progress-bar {
            display: block;
            background-color: $light-lite-gray-drawer;
            border-radius: 5px;
            height: 10px;
            margin-top: 5px;
            margin-bottom: 10px;
        }

        .progress {
            background-color: $site-green;
            height: 100%;
            border-radius: 5px;
        }

        button {
            background-color: transparent;
            border: none;
            color: white;
            font-size: 1.5rem;
            cursor: pointer;
            flex-shrink: 0;
            position: absolute;
            right: 3px;
            top: 3px;
            font-weight: lighter;
        }
    }

    .drawer-content {
        padding: 10px;

        .section {
            margin-top: 20px;
        }

        h3 {
            margin-bottom: 10px;
            text-transform: none !important;
            font-size: 16px;
        }

        ul {
            list-style: none;
            padding: 0 !important;
            margin: 0px !important;
        }

        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            padding: 10px;
            border-radius: 5px;
            background-color: $light-blue-drawer;
            transition: background-color 0.3s;
            font-weight: bold;
            font-size: 16px;
        }

        .item-title {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .checkmark {
            /* Warna latar belakang hijau */
            background-color: $site-green;
            width: 24px;
            height: 24px;
            /* Membuat lingkaran */
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 10px;

            i {
                /* Warna ikon centang */
                color: white;
                /* Ukuran ikon */
                font-size: 16px;
                margin-left: -4px !important;
            }
        }

        .plusmark {
            /* Warna latar belakang hijau */
            background-color: $light-gray-drawer-02;
            width: 24px;
            height: 24px;
            /* Membuat lingkaran */
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 10px;

            i {
                /* Warna ikon centang */
                color: $light-gray-drawer;
                /* Ukuran ikon */
                font-size: 16px;
                margin-left: -4px !important;
            }
        }

        .edit-consent {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;

            .title {
                font-size: 16px;
            }
        }
    }

    .action-button {
        border: solid 1px $light-gray-drawer;
        border-radius: 20px;
        padding: 5px 10px;
        cursor: pointer;
        font-weight: normal;
        font-size: 10px !important;
        transition: background-color 0.3s;
        background-color: $light-blue-drawer;
        color: $light-gray-drawer;
        text-decoration: none;
    }

    .action-button:hover {
        background-color: $light-gray-drawer;
        color: white;
    }

    .disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .download-button {
        margin-top: 10px;
        widows: 100%;
        /* Jarak atas tombol */
    }

    .button-link {
        display: inline-flex;
        align-items: center;
        padding: 10px 20px;
        border: 2px solid $light-gray-drawer;
        border-radius: 25px;
        background-color: white;
        color: $light-gray-drawer;
        text-decoration: none;
        font-weight: bold;
        transition: background-color 0.3s, color 0.3s;
        width: 100%;
        justify-content: center;
    }

    .button-link .icon {
        margin-right: 10px;
        /* Jarak antara ikon dan teks */
    }

    .button-link:hover {
        background-color: $light-gray-drawer;
        ;
        /* Warna latar belakang saat hover */
        color: white;
        /* Warna teks saat hover */
    }
}

.vue-js-switch {
    .v-switch-label{
        color: $light-gray-drawer !important;
    }
}
</style>